import {Theme} from '@mui/material/styles';

export const createStyles = (theme: Theme) => ({
	cardContainer: {
		flex: 1,
		height: '100%',
	},
	therapyTitle: {
		fontSize: '18px',
		fontWeight: 400,
		lineHeight: 1.6,
		letterSpacing: '0.15px',
	},
	sessionsText: {
		fontSize: '16px',
		fontWeight: 400,
		lineHeight: 1.43,
		letterSpacing: '0.17px',
		color: theme.palette.text.primary,
	},
	iconBox: {
		pt: 0.25,
	},
	sectionLabel: {
		fontSize: '14px',
		fontWeight: 400,
		lineHeight: 1.5,
		letterSpacing: '0.15px',
		color: theme.palette.text.secondary,
	},
	sectionValue: {
		fontSize: '16px',
		fontWeight: 400,
		lineHeight: 1.43,
		letterSpacing: '0.17px',
		color: theme.palette.text.primary,
	},
	detailsButtonContainer: {
		pt: 1,
	},
	detailsButton: {
		fontSize: '14px',
		fontWeight: 600,
		lineHeight: '24px',
		letterSpacing: '0.4px',
		color: theme.palette.primary.main,
		textTransform: 'none',
		padding: '6px 8px',
	},
});
